import React from 'react'
import RightHeader from './header'
import Inputs from './inputs'
import { Col } from 'react-bootstrap'
import "./index.scss"

const RightSection = () => {
  return (
    <Col className='right-col'>
      <RightHeader/>
      <Inputs/>
    </Col>
  )
}

export default RightSection
